// extracted by mini-css-extract-plugin
export default {"block":"SwitchBlock_block__WlHy1","text":"SwitchBlock_text__yFlGU"};